import { useParams } from 'react-router-dom'

export const useNumberParams = (paramName: string): number => {
  const params = useParams()
  return Number(params[paramName])
}
